import { isChatTurnInterruptedResponse } from '@terra/shared-utils';
import { create } from 'zustand';

type ChatTurnInterruptedState = {
  interruptedChatIds: Set<string>;
  setTurnInterrupted: (chatId: string, isInterrupted: boolean) => void;
};

export const useChatTurnInterruptedStore = create<ChatTurnInterruptedState>(
  (set, get) => ({
    interruptedChatIds: new Set(),
    setTurnInterrupted: (chatId, isInterrupted) => {
      if (get().interruptedChatIds.has(chatId) === isInterrupted) {
        return;
      }

      const next = new Set(get().interruptedChatIds);

      if (isInterrupted) {
        next.add(chatId);
      } else {
        next.delete(chatId);
      }

      set({ interruptedChatIds: next });
    },
  }),
);

export const settleChatStreamResumeIdleStatus = ({
  chatId,
  response,
  clearError,
}: {
  chatId: string;
  response: Response;
  clearError?: () => void;
}): void => {
  if (response.status !== 204) {
    return;
  }

  clearError?.();

  if (isChatTurnInterruptedResponse(response)) {
    useChatTurnInterruptedStore.getState().setTurnInterrupted(chatId, true);
  }
};
